import { AfterContentInit, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

import { ErrorHandlerService, NotyService, VerificationService } from '@app/services';
import { SecurityVerificationType } from '@app/models';
import { LoaderService } from '@app/shared';
import { TranslateService } from '@ngx-translate/core';

export type ModalResult = SecurityVerificationType;
export interface ModalPublicProperties {
  verification: SecurityVerificationType;
  documentId: string;
}

@Component({
  selector: 'app-verification-id-analyzer-modal',
  templateUrl: './verification-id-analyzer-modal.component.html',
  styleUrls: ['./verification-id-analyzer-modal.component.scss'],
  standalone: false
})
export class VerificationIdAnalyzerModalComponent implements OnInit, ModalPublicProperties, AfterContentInit {
  @Input() verification: SecurityVerificationType;
  @Input() documentId: string;
  isLoading = false;
  isMobile = false;
  isTimedOut = true;

  constructor(
    public modal: NgbActiveModal,
    private translateService: TranslateService,
    private errorHandlerService: ErrorHandlerService,
    private notyService: NotyService,
    private loaderService: LoaderService,
    private verificationService: VerificationService
  ) {}

  ngOnInit() {
    this.isMobile = window.innerWidth <= 992;
  }

  ngAfterContentInit() {
    if (!this.verification?.payload?.url) {
      this.verificationService.generateSecurityVerificationCode({ id: this.verification.id }).subscribe({
        next: verificationPayload => (this.verification.payload = verificationPayload),
        error: error => this.errorHandlerService.handle(error)
      });
    }
    setTimeout(() => (this.isTimedOut = false), 20000);
  }

  checkSecurityVerification() {
    this.isLoading = true;
    this.loaderService.show();

    this.verificationService
      .checkSecurityVerification({ document_id: this.documentId, id: this.verification.id })
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.loaderService.hide();
        })
      )
      .subscribe({
        next: response => {
          if (response.payload?.failcode) {
            this.notyService.warning(this.translateService.instant('notyService.biometricRejectedManualVerification'));
            this.modal.close(response as ModalResult);
          } else if (!response.payload?.failcode && !response.verified_at) {
            this.notyService.warning(this.translateService.instant('notyService.biometricNotProcessed'), 15000);
          } else {
            this.modal.close(response as ModalResult);
          }
        },
        error: error => {
          this.errorHandlerService.handle(error);
        }
      });
  }
}
